import { ConfigRoutes, getPath } from "./routes.path.ts";
import type { NavigateFunction } from "react-router-dom";

export const UserTabLayoutConfig = {
  tabBarHandlers: (navigate: NavigateFunction) => ({
    onScanClick: () => navigate(getPath(ConfigRoutes.SCAN)),
    onDevicesClick: () => navigate(getPath(ConfigRoutes.DEVICES)),
    onSettingsClick: () => navigate(getPath(ConfigRoutes.PROFILE)),
  }),

  headerHandlers: (navigate: NavigateFunction) => ({
    onClickBack: () => navigate(-1),
  }),
};
